import React from "react";

export default function ZaPodjetja() {
  return (
    <div
      className="min-h-screen"
      style={{
        background: "linear-gradient(135deg, #005d7e, #022e59, #fafafa)",
      }}
    >
      {/* HEADER */}
      <header className="relative z-10">
        <div className="max-w-7xl mx-auto px-5 py-6 flex justify-center">
          <a href="/">
            <img
              src="/e2fsilogo.png"
              alt="e2f.si"
              style={{ width: "160px" }}
            />
          </a>
        </div>
      </header>

      {/* HERO */}
      <section className="text-center px-5 pt-28 pb-40">
        <div className="max-w-4xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl font-semibold mb-6">
            Za podjetja
          </h1>
          <p className="text-xl text-white/90 leading-relaxed">
            Merilo digitalne odličnosti.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="bg-white rounded-t-[40px] -mt-24 pt-24 pb-24">
        <div className="max-w-5xl mx-auto px-5 space-y-24">

          {/* GLAVNO BESEDILO */}
          <div className="text-center">
            <h2 className="text-3xl font-semibold text-gray-800 mb-6">
              Merilo digitalne odličnosti.
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
              Vpis v e2f.si je potrditev, da vaše podjetje sledi modernim
              standardom poslovanja. V bazo vključujemo le ponudnike z
              urejeno spletno stranjo ali Facebook profilom, saj s tem
              zagotavljamo najboljšo izkušnjo za uporabnike.
              <br /><br />
              Če menite, da vaše podjetje ustreza našim kriterijem in ga še ni
              v bazi, nas kontaktirajte za preverjanje vpisa.
            </p>
          </div>

          {/* DODATNA VREDNOST – zakaj biti zraven */}
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-10 text-center">
              Zakaj biti prisoten na e2f.si?
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              {[
                {
                  icon: "⭐",
                  title: "Znak zaupanja",
                  text: "Prisotnost na e2f.si pomeni, da je vaše podjetje prepoznano kot zaupanja vreden in aktiven ponudnik.",
                },
                {
                  icon: "🎯",
                  title: "Relevantni uporabniki",
                  text: "Uporabniki vas najdejo na podlagi konkretne potrebe, ne naključnega brskanja.",
                },
                {
                  icon: "🔗",
                  title: "Neposreden obisk",
                  text: "Uporabnike usmerimo neposredno na vašo spletno stran ali uradni profil – brez posrednikov.",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all hover:-translate-y-1 text-center"
                >
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h4 className="text-xl font-semibold mb-3 text-gray-800">
                    {item.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* KRITERIJI */}
          <div className="bg-indigo-50 rounded-2xl p-10 text-center">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6">
              Osnovni kriteriji za vpis
            </h3>

            <ul className="space-y-4 text-gray-700 text-lg">
              <li>✔ aktivno podjetje s preverljivimi podatki</li>
              <li>✔ urejena spletna stran ali Facebook poslovni profil</li>
              <li>✔ jasno predstavljene storitve ali izdelki</li>
              <li>✔ osredotočenost na slovenski trg</li>
            </ul>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Menite, da spadate v naš izbor?
            </h3>
            <p className="text-gray-600 mb-8 text-lg">
              Stopite v stik z nami in preverili bomo možnost vpisa vašega podjetja.
            </p>

            <h1 className="text-4xl font-semibold">info@e2f.si</h1>
          </div>

        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-white px-5 py-16 pb-8">
        <div className="max-w-7xl mx-auto text-center">
          <img
            src="/e2fsilogo.png"
            alt="e2f.si"
            style={{ width: "100px" }}
            className="mx-auto mb-4"
          />

          <div className="border-t border-white/10 mt-10 pt-6 text-sm text-white/60">
            © {new Date().getFullYear()} e2f.si. Vse pravice pridržane.
          </div>
        </div>
      </footer>
    </div>
  );
}
